/**
 * At and above this width the page is laid out for desktop, so the desktop
 * creative is the one that fits (the top banner's box becomes 728x90 here:
 * top-header.tsx TOP_AD_MIN_WIDTH, styles/components/top-header.scss).
 *
 * The variant used to follow `isMobile` from react-device-detect, which reads
 * the user agent. An iPad or a touch laptop counts as mobile there but gets the
 * desktop layout, so the 728x90 top banner was asked for a 320x50 and showed a
 * phone ad in a desktop box (2026-10-14). The layout goes by width; so does
 * the ad now.
 */
export const DESKTOP_AD_MIN_WIDTH = 728

/** Desktop or phone creative for this viewport. Measured once: re-picking on resize would define a second GAM slot. */
export function wantsDesktopAd(viewportWidth: number): boolean {
    return viewportWidth >= DESKTOP_AD_MIN_WIDTH
}
